import { featureFlags } from '@/featureFlags';
import LoginPage from '@/features/auth/pages/LoginPage';
import SelectRestaurantPage from '@/features/auth/pages/SelectRestaurantPage';
import SettingsPage from '@/features/settings/pages/SettingsPage';
import TableEditFormPage from '@/features/reservation-setup/pages/TableEditFormPage';
import AdvancedTablesPage from '@/features/reservation-setup/pages/AdvancedTablesPage';
import FloorPlanPage from '@/features/reservation-setup/pages/FloorPlanPage';
import ShiftDetailPage from '@/features/reservation-setup/pages/ShiftDetailPage';
import ShiftsPage from '@/features/reservation-setup/pages/ShiftsPage';
import ReservationSetupPage from '@/features/reservation-setup/pages/ReservationSetupPage';
import TablePlanPage from '@/features/reservation-setup/pages/TablePlanPage';
import TablesPage from '@/features/reservation-setup/pages/TablesPage';
import ZonesPage from '@/features/reservation-setup/pages/ZonesPage';
import MenusPage from '@/features/menu/pages/MenusPage';
import AllergenLabelingPage from '@/features/allergen-labeling/pages/AllergenLabelingPage';
import MenuPage, { SectionEditPage } from '@/features/menu/pages/MenuPage';
import { ArchivedProductsPage } from '@/features/menu/pages/ArchivedProductsPage';
import CreateMenuWithAiPage from '@/features/menu/pages/CreateMenuWithAiPage';
import MenuImportReviewPage from '@/features/menu/pages/MenuImportReviewPage';
import ProductPage, {
  PricingOverviewPage,
  BasePriceEditPage,
  ChannelPriceEditPage,
  OptionEditPage,
  ChoiceEditPage,
  ChoiceAllergensEditPage,
  AllergensEditPage,
  AllergenCodesEditPage,
  LabelsEditPage,
} from '@/features/menu/pages/ProductPage';
import RestaurantSetupPage from '@/features/restaurant-setup/pages/RestaurantSetupPage';
import BrandingPage from '@/features/restaurant-setup/pages/BrandingPage';
import StorefrontLinkPage from '@/features/settings/pages/StorefrontLinkPage';
import SettingHistoryPage from '@/features/settings/pages/SettingHistoryPage';
import RestaurantSwitcherPage from '@/features/settings/pages/RestaurantSwitcherPage';
import MyProfilePage from '@/features/profile/pages/MyProfilePage';
import NotificationSettingsPage from '@/features/notifications/pages/NotificationSettingsPage';
import MailSettingsPage from '@/features/settings/pages/MailSettingsPage';
import CreateReservationPage from '@/features/reservations/pages/CreateReservationPage';
import PendingQueuePage from '@/features/reservations/pages/PendingQueuePage';
import ReservationDetailPage from '@/features/reservations/pages/ReservationDetailPage';
import ReservationsWorkspacePage from '@/features/reservations/pages/ReservationsWorkspacePage';
import OrdersWorkspacePage from '@/features/orders/pages/OrdersWorkspacePage';
import OrderDetailPage from '@/features/orders/pages/OrderDetailPage';
import AwaitingPaymentPage from '@/features/orders/pages/AwaitingPaymentPage';
import OrderHistoryPage from '@/features/orders/pages/OrderHistoryPage';
import OrderSetupPage from '@/features/order-setup/pages/OrderSetupPage';
import PaymentsSettingsPage from '@/features/payments/pages/PaymentsSettingsPage';
import ConnectProviderFormPage from '@/features/payments/pages/ConnectProviderFormPage';
import CustomersPage from '@/features/customers/pages/CustomersPage';
import CreateCustomerPage from '@/features/customers/pages/CreateCustomerPage';
import CustomerDetailPage from '@/features/customers/pages/CustomerDetailPage';
import OpeningHoursPage from '@/features/opening-hours/pages/OpeningHoursPage';
import ExceptionsPage from '@/features/opening-hours/pages/ExceptionsPage';
import ExceptionFormPage from '@/features/opening-hours/pages/ExceptionFormPage';
import ReservationHoursPage from '@/features/opening-hours/pages/ReservationHoursPage';
import OrderHoursPage from '@/features/opening-hours/pages/OrderHoursPage';
import OrderShiftsPage from '@/features/order-setup/pages/OrderShiftsPage';
import OrderShiftFormPage from '@/features/order-setup/pages/OrderShiftFormPage';
import OrderHolidayHoursFormPage from '@/features/order-setup/pages/OrderHolidayHoursFormPage';
import DeliveryZoneFormPage from '@/features/order-setup/pages/DeliveryZoneFormPage';
import DeliveryZoneMapFormPage from '@/features/order-setup/pages/DeliveryZoneMapFormPage';
import RestaurantLocationPage from '@/features/order-setup/pages/RestaurantLocationPage';
import ManualPaymentMethodFormPage from '@/features/order-setup/pages/ManualPaymentMethodFormPage';
import TablesWorkspacePage from '@/features/table-ordering/pages/TablesWorkspacePage';
import ExpectedArrivalsPage from '@/features/table-ordering/pages/ExpectedArrivalsPage';
import WaitlistPage from '@/features/waitlist/pages/WaitlistPage';
import TableSessionHistoryPage from '@/features/table-ordering/pages/TableSessionHistoryPage';
import TableSessionDetailPage from '@/features/table-ordering/pages/TableSessionDetailPage';
import TableSessionTimelinePage from '@/features/table-ordering/pages/TableSessionTimelinePage';
import AddRoundPage from '@/features/table-ordering/pages/AddRoundPage';
import BillPage from '@/features/table-ordering/pages/BillPage';
import BillSplitPage from '@/features/table-ordering/pages/BillSplitPage';
import BillCollectPage from '@/features/table-ordering/pages/BillCollectPage';
import BillPaymentPage from '@/features/table-ordering/pages/BillPaymentPage';
import ConfigureItemPage from '@/features/table-ordering/pages/ConfigureItemPage';
import TableOrderingSettingsPage from '@/features/table-ordering/pages/TableOrderingSettingsPage';
import LabelsSettingsPage from '@/features/labels/pages/LabelsSettingsPage';
import LabelFormPage from '@/features/labels/pages/LabelFormPage';
import PurgeSettingsPage from '@/features/purge/pages/PurgeSettingsPage';
import PurgeRunHistoryPage from '@/features/purge/pages/PurgeRunHistoryPage';
// Discount/Promotions tooling - always enabled (no longer feature-flagged).
import PromotionsListPage from '@/features/promotions/pages/PromotionsListPage';
import PromotionEditPage from '@/features/promotions/pages/PromotionEditPage';
import LoyaltySettingsPage from '@/features/loyalty/pages/LoyaltySettingsPage';
import GiftCardsPage from '@/features/gift-cards/pages/GiftCardsPage';
import GiftCardDetailPage from '@/features/gift-cards/pages/GiftCardDetailPage';
import StaffPage from '@/features/staff/pages/StaffPage';
import ReportsPage from '@/features/reports/pages/ReportsPage';
import CustomerServicePage from '@/features/customer-service/pages/CustomerServicePage';
import ActionCenterPage from '@/features/action-center/pages/ActionCenterPage';
import PrintersPage from '@/features/print/pages/PrintersPage';
import PrintJobsPage from '@/features/print/pages/PrintJobsPage';
import PrinterEditFormPage from '@/features/print/pages/PrinterEditFormPage';
import PrintPageEditPage from '@/features/print/pages/PrintPageEditPage';
import PrintRoutingPage from '@/features/print/pages/PrintRoutingPage';
import PrintBehaviourPage from '@/features/print/pages/PrintBehaviourPage';
import TableQrSheetPage from '@/features/table-ordering/pages/TableQrSheetPage';
import { useAuthStore } from '@/stores/auth.store';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { canInScope, resolveAbility, type CaslAction, type CaslSubject } from '@/lib/ability';
import { confirmDiscardChanges } from '@/utils/unsavedChanges';
import type { Router } from 'framework7/types';

// Settings detail forms publish their dirty state via SettingsSaveNav; this gate
// runs when leaving such a route (switching settings sections, or Back) and asks
// to discard unsaved edits before allowing it. Resolves immediately when nothing
// is dirty.
const guardUnsavedChanges = function (
  this: Router.RouteCallbackCtx,
  { resolve, reject }: Router.RouteCallbackCtx,
) {
  void confirmDiscardChanges().then((proceed) => (proceed ? resolve() : reject()));
};

const requireAuth = function (
  this: Router.RouteCallbackCtx,
  { resolve, reject, router }: Router.RouteCallbackCtx,
) {
  const { isAuthenticated } = useAuthStore.getState();
  if (isAuthenticated) {
    resolve();
  } else {
    reject();
    router.navigate('/login', { reloadCurrent: true });
  }
};

const requireRestaurant = function (
  this: Router.RouteCallbackCtx,
  { resolve, reject, router }: Router.RouteCallbackCtx,
) {
  const { isAuthenticated } = useAuthStore.getState();
  const { selectedRestaurantId } = useRestaurantStore.getState();

  if (!isAuthenticated) {
    reject();
    router.navigate('/login', { reloadCurrent: true });
  } else if (!selectedRestaurantId) {
    reject();
    router.navigate('/select-restaurant', { reloadCurrent: true });
  } else {
    resolve();
  }
};

const requireCan = (action: CaslAction, subjectType: CaslSubject) =>
  function (this: Router.RouteCallbackCtx, ctx: Router.RouteCallbackCtx) {
    const { isAuthenticated } = useAuthStore.getState();
    const { userContext, selectedRestaurantId, selectedFranchiseId } =
      useRestaurantStore.getState();
    const ability = resolveAbility(userContext);
    if (isAuthenticated && selectedRestaurantId) {
      if (
        ability.status === 'no-context' ||
        !canInScope(ability, action, subjectType, {
          restaurantId: selectedRestaurantId,
          franchiseId: selectedFranchiseId,
        })
      ) {
        ctx.reject();
        ctx.router.navigate('/settings/', { reloadCurrent: true });
        return;
      }
    }
    requireRestaurant.call(this, ctx);
  };

const redirectIfAuth = function (
  this: Router.RouteCallbackCtx,
  { resolve, reject, router }: Router.RouteCallbackCtx,
) {
  const { isAuthenticated } = useAuthStore.getState();
  if (!isAuthenticated) {
    resolve();
  } else {
    reject();
    router.navigate('/', { reloadCurrent: true });
  }
};

const allRoutes: Router.RouteParameters[] = [
  // Public
  {
    path: '/login',
    component: LoginPage,
    beforeEnter: redirectIfAuth,
  },

  // Auth required, no restaurant needed
  {
    path: '/select-restaurant',
    component: SelectRestaurantPage,
    beforeEnter: requireAuth,
  },

  // Auth + restaurant required
  {
    // The reservations workspace lives at /reservation; / just redirects to it.
    path: '/',
    redirect: '/reservation',
  },
  {
    path: '/reservation',
    component: ReservationsWorkspacePage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/reservations/pending',
    component: PendingQueuePage,
    beforeEnter: requireRestaurant,
  },
  {
    // Guard in-app Back/nav while a reservation is being drafted - the form
    // publishes its dirty state via useUnsavedGuard, same as settings forms.
    // (Browser refresh/close is covered by useUnsavedGuard's beforeunload.)
    path: '/reservations/create',
    component: CreateReservationPage,
    beforeEnter: requireRestaurant,
    beforeLeave: guardUnsavedChanges,
  },
  // Phone: tapping a reservation pushes a detail page (native iOS feel -
  // back swipe, navbar transition). Wide layouts keep the inspector docked
  // and never navigate here, but the route stays usable for deep links.
  {
    path: '/reservations/:id',
    component: ReservationDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/orders',
    component: OrdersWorkspacePage,
    beforeEnter: requireRestaurant,
  },
  {
    // Must precede '/orders/:id' so "history" isn't captured as an order id.
    path: '/orders/history',
    component: OrderHistoryPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/orders/awaiting-payment',
    component: AwaitingPaymentPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/orders/:id',
    component: OrderDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables',
    component: TablesWorkspacePage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/history',
    component: TableSessionHistoryPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/arrivals',
    component: ExpectedArrivalsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/waitlist',
    component: WaitlistPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId',
    component: TableSessionDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/timeline',
    component: TableSessionTimelinePage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/add-round',
    component: AddRoundPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/add-round/configure',
    component: ConfigureItemPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/bill',
    component: BillPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/bill/split',
    component: BillSplitPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/bill/collect',
    component: BillCollectPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/tables/session/:sessionId/bill/payment',
    component: BillPaymentPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/table-ordering',
    component: TableOrderingSettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/labels',
    component: LabelsSettingsPage,
    beforeEnter: requireRestaurant,
  },
  // Literal `new` must precede ':labelId' so it isn't captured as an id.
  {
    path: '/settings/labels/new',
    component: LabelFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/labels/:labelId',
    component: LabelFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/tidy-up',
    component: PurgeSettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/tidy-up/history',
    component: PurgeRunHistoryPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/payments',
    component: PaymentsSettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    // `:provider` of "new" opens a blank connect form; PAYPAL/PAYCAT re-connects that one.
    path: '/settings/payments/connect/:provider',
    component: ConnectProviderFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/promotions',
    component: PromotionsListPage,
    beforeEnter: requireRestaurant,
  },
  {
    // `:promotionId` is the literal `new` for creation, else an existing id.
    path: '/promotions/:promotionId',
    component: PromotionEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/loyalty',
    component: LoyaltySettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/gift-cards',
    component: GiftCardsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/gift-cards/:giftCardId',
    component: GiftCardDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/staff',
    component: StaffPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/reports',
    component: ReportsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers',
    component: PrintersPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers/behaviour',
    component: PrintBehaviourPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers/routing',
    component: PrintRoutingPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers/routing/new',
    component: PrintPageEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    // Param route after /new so it doesn't shadow it.
    path: '/settings/printers/routing/:pageId',
    component: PrintPageEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers/jobs',
    component: PrintJobsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/printers/new',
    component: PrinterEditFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    // Param route last so it doesn't shadow /routing, /jobs, /new above.
    path: '/settings/printers/:printerId',
    component: PrinterEditFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/table-ordering/qr',
    component: TableQrSheetPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/orders',
    component: OrderSetupPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/orders/shifts',
    component: OrderShiftsPage,
    beforeEnter: requireCan('manage', 'OrderShift'),
  },
  {
    path: '/settings/orders/shifts/new/:orderType',
    component: OrderShiftFormPage,
    beforeEnter: requireCan('manage', 'OrderShift'),
  },
  {
    path: '/settings/orders/shifts/:shiftId',
    component: OrderShiftFormPage,
    beforeEnter: requireCan('manage', 'OrderShift'),
  },
  {
    path: '/settings/orders/holidays/new/:orderType',
    component: OrderHolidayHoursFormPage,
    beforeEnter: requireCan('manage', 'OrderShift'),
  },
  {
    path: '/settings/orders/holidays/:holidayId',
    component: OrderHolidayHoursFormPage,
    beforeEnter: requireCan('manage', 'OrderShift'),
  },
  {
    // Business-profile sub-page (opened from Hồ sơ doanh nghiệp). Under
    // /settings/restaurant so the nav rail keeps the profile row highlighted and
    // the Back button returns to the profile, not the order settings.
    path: '/settings/restaurant/location',
    component: RestaurantLocationPage,
    beforeEnter: requireRestaurant,
  },
  {
    // Map-drawn (POLYGON) zone editor. Registered before `:zoneId` so "map"
    // isn't captured as a zone id. `:zoneId` of "new" opens a blank form.
    path: '/settings/orders/delivery-zones/map/:zoneId',
    component: DeliveryZoneMapFormPage,
    beforeEnter: requireCan('manage', 'DeliveryZone'),
  },
  {
    // `:zoneId` of "new" opens a blank form.
    path: '/settings/orders/delivery-zones/:zoneId',
    component: DeliveryZoneFormPage,
    beforeEnter: requireCan('manage', 'DeliveryZone'),
  },
  {
    // `:methodId` of "new" opens a blank form. Lives under /settings/payments/*
    // since manual methods now sit in the Payments tab (moved out of order setup).
    path: '/settings/payments/methods/:methodId',
    component: ManualPaymentMethodFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings',
    component: SettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/customers',
    component: CustomersPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/customers/create',
    component: CreateCustomerPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/customers/:customerId',
    component: CustomerDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation',
    component: TablePlanPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/tables',
    component: TablesPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/zones',
    component: ZonesPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/setup',
    component: ReservationSetupPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/shifts',
    component: ShiftsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/shifts/:shiftId',
    component: ShiftDetailPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/floor-plan',
    component: FloorPlanPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/advanced-tables',
    component: AdvancedTablesPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/advanced-tables/:tableId',
    component: TableEditFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu',
    component: MenusPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/allergen-labeling',
    component: AllergenLabelingPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/create-with-ai',
    component: CreateMenuWithAiPage,
    beforeEnter: requireCan('create', 'AiThread'),
  },
  {
    path: '/menu/:menuId',
    component: MenuPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/archived',
    component: ArchivedProductsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/import-review',
    component: MenuImportReviewPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/category/:categoryId',
    component: SectionEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId',
    component: ProductPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/pricing',
    component: PricingOverviewPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/price',
    component: BasePriceEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/price/:channel',
    component: ChannelPriceEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/option/:optionId/choice/:choiceId/allergens',
    component: ChoiceAllergensEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/option/:optionId/choice/:choiceId',
    component: ChoiceEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/option/:optionId',
    component: OptionEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/allergens',
    component: AllergensEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/allergen-codes',
    component: AllergenCodesEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/menu/:menuId/product/:productId/labels',
    component: LabelsEditPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/switch-restaurant',
    component: RestaurantSwitcherPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/profile',
    component: MyProfilePage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/restaurant',
    component: RestaurantSetupPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/branding',
    component: BrandingPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/storefront-link',
    component: StorefrontLinkPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/history',
    component: SettingHistoryPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/opening-hours',
    component: OpeningHoursPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/holidays',
    component: ExceptionsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/holidays/new',
    component: ExceptionFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/holidays/:exceptionId',
    component: ExceptionFormPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/reservation/hours',
    component: ReservationHoursPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/orders/hours',
    component: OrderHoursPage,
    beforeEnter: requireCan('manage', 'OpeningHours'),
  },
  {
    path: '/settings/notifications',
    component: NotificationSettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/settings/mail',
    component: MailSettingsPage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/customer-service',
    component: CustomerServicePage,
    beforeEnter: requireRestaurant,
  },
  {
    path: '/action-center',
    component: ActionCenterPage,
    beforeEnter: requireRestaurant,
  },
];

// ── Settings master-detail split ────────────────────────────────────────────
// On desktop (≥768px) the `/settings` route becomes a master pane (the settings
// nav list) shown beside the app sidebar, with these sub-pages rendered in the
// detail pane on the right. Below 768px the View falls back to normal push
// navigation (mobile behaviour unchanged).
//
// Menu, Customers, Promotions and Reports deliberately stay TOP-LEVEL full-width
// pages - even though some live under /settings/* - because they're primary nav
// destinations (reached from the app sidebar) with their own deep sub-flows.
export const SETTINGS_DETAIL_PATHS = new Set<string>([
  '/settings/table-ordering',
  '/settings/table-ordering/qr',
  '/settings/labels',
  '/settings/tidy-up',
  '/settings/tidy-up/history',
  '/settings/labels/new',
  '/settings/labels/:labelId',
  '/settings/loyalty',
  '/settings/gift-cards',
  '/settings/gift-cards/:giftCardId',
  '/settings/staff',
  '/settings/printers',
  '/settings/printers/behaviour',
  '/settings/printers/routing',
  '/settings/printers/routing/new',
  '/settings/printers/routing/:pageId',
  '/settings/printers/jobs',
  '/settings/printers/new',
  '/settings/printers/:printerId',
  '/settings/orders',
  '/settings/orders/hours',
  '/settings/orders/shifts',
  '/settings/orders/shifts/new/:orderType',
  '/settings/orders/shifts/:shiftId',
  '/settings/reservation',
  '/settings/reservation/tables',
  '/settings/reservation/zones',
  '/settings/reservation/setup',
  '/settings/reservation/hours',
  '/settings/reservation/shifts',
  '/settings/reservation/shifts/:shiftId',
  '/settings/reservation/floor-plan',
  '/settings/reservation/advanced-tables',
  '/settings/restaurant',
  '/settings/branding',
  '/settings/storefront-link',
  '/settings/opening-hours',
  '/settings/holidays',
  '/settings/holidays/new',
  '/settings/holidays/:exceptionId',
  '/settings/notifications',
  '/settings/mail',
  '/settings/history',
]);

// Menu product-editor pages hold unsaved draft state (price, option, choice,
// allergen/label edits) but are top-level pages, not settings detail - so they
// get the same leave-guard without joining SETTINGS_DETAIL_PATHS (which also
// carries master-detail semantics). The product detail page itself is omitted:
// its name/description edits live in bottom sheets that self-guard, and its
// toggles persist immediately.
const MENU_EDIT_GUARD_PATHS = new Set<string>([
  '/menu/:menuId/category/:categoryId',
  '/menu/:menuId/product/:productId/pricing',
  '/menu/:menuId/product/:productId/price',
  '/menu/:menuId/product/:productId/price/:channel',
  '/menu/:menuId/product/:productId/allergens',
  '/menu/:menuId/product/:productId/labels',
]);

// Feature-flagged surfaces: drop their routes entirely when the flag is off so
// the pages aren't reachable (even by direct URL) on deployed builds. Their nav
// entry points are gated separately in Sidebar/SettingsPage.
const FLAG_GATED_PATHS: Record<string, boolean> = {
  '/settings/loyalty': featureFlags.loyalty,
  '/customer-service': featureFlags.customerService,
};

// Prefix-gated subtrees: every route under the prefix drops when the flag is
// off. The whole `/tables/*` dine-in flow (session, rounds, bill) lives behind
// the local table-ordering flag.
const FLAG_GATED_PREFIXES: { prefix: string; enabled: boolean }[] = [
  { prefix: '/tables', enabled: featureFlags.tableOrdering },
  { prefix: '/settings/tidy-up', enabled: featureFlags.purge },
];

const enabledRoutes = allRoutes.filter((r) => {
  if (typeof r.path !== 'string') return true;
  if (FLAG_GATED_PATHS[r.path] === false) return false;
  const gated = FLAG_GATED_PREFIXES.find(
    (g) => r.path === g.prefix || (r.path as string).startsWith(g.prefix + '/'),
  );
  return !gated || gated.enabled;
});

// Settings is NOT a Framework7 master-detail view (that mode's detail-page
// transition leaves React pages without `page-current` → gray screen). Instead
// `/settings` renders a full-page shell with its own left nav + a nested plain
// `<View>` (see SettingsPage); the sub-pages below are ordinary routes that the
// nested view (desktop) or the settings tab (mobile) PUSHES like any other view.
// They only keep the unsaved-changes gate on leave.
const routes: Router.RouteParameters[] = enabledRoutes.map((r) =>
  typeof r.path === 'string' &&
  (SETTINGS_DETAIL_PATHS.has(r.path) || MENU_EDIT_GUARD_PATHS.has(r.path))
    ? { ...r, beforeLeave: guardUnsavedChanges }
    : r,
);

export default routes;
